//
//
//
//
//
//
//
//
//

// @ts-nocheck
export default {
	name: '',
	props: {
		isclose: {
			default: false,
		},
	},
	data() {
		return {}
	},
	methods: {
		handle() {
			this.$emit('clickMenuMobile', !this.isclose)
		},
	},
}
